<template>
	<img :src="modalData?.data?.imageSrc" class="fullscreen-image"/>
</template>
<script lang="ts">
import { ImagesModalMixin } from "@/utils/mixins";
import { defineComponent } from "vue";

export default defineComponent({
	mixins: [ImagesModalMixin]
})
</script>

<style scoped>
	.fullscreen-image { 
		max-width: 100vw;
		max-height: 100vh;
	}
</style>
